import { render, staticRenderFns } from "./BrandSwitcher.vue?vue&type=template&id=7f3e260d&scoped=true&"
import script from "./BrandSwitcher.vue?vue&type=script&lang=js&"
export * from "./BrandSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BrandSwitcher.vue?vue&type=style&index=0&id=7f3e260d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e260d",
  null
  
)

export default component.exports